import { SimpleGrid } from '@mantine/core';
import { ProfileFormField } from '../components/ProfileFormField';
import { ProfileFormList } from '../components/ProfileFormList';
import EntityFormProvider from '../EntityFormProvider';

export default function AdvisorsProfessionalConnections() {
  const defaultFields = {
    type: '',
    name: '',
    phone_number: '',
    email: '',
    address: '',
  };

  return (
    <EntityFormProvider title="Advisors/professional connections">
      <ProfileFormList
        entityType="ProfessionalConnection"
        addButtonLabel="Add"
        defaultFields={defaultFields}
      >
        {index => (
          <>
            <SimpleGrid cols={{ base: 1, sm: 2 }}>
              <ProfileFormField
                entityType="ProfessionalConnection"
                fieldName="type"
                label="Type"
                index={index}
              />
              <ProfileFormField
                entityType="ProfessionalConnection"
                fieldName="name"
                label="Name"
                index={index}
              />
              <ProfileFormField
                entityType="ProfessionalConnection"
                fieldName="phone_number"
                index={index}
              />
              <ProfileFormField
                entityType="ProfessionalConnection"
                fieldName="email"
                index={index}
              />
            </SimpleGrid>
            <ProfileFormField
              entityType="ProfessionalConnection"
              fieldName="address"
              index={index}
            />
          </>
        )}
      </ProfileFormList>
    </EntityFormProvider>
  );
}
